<template>
  <div id="Footer">
    <div class="container">
      <div class="row">
        <!--PC端显示-->
        <div class="col-md-8 big-size" style="padding-top:16px;">
          <ul class="list-unstyled list-link">
            <li><a href="/#/about-us">关于我们</a></li>
            <li><a href="/#/customer">客户故事</a></li>
            <li><a href="/#/progress">发展历程</a></li>
            <li><a href="/#/news">资讯动态</a></li>
            <li><a href="/#/questions">常见问题</a></li>
            <li><a href="/#/contact">联系我们</a></li>
          </ul>
          <p class="text-left gray-8 font-15">上海嘉定及时雨小额贷款股份有限公司 All rights reserved　<a href="https://beian.miit.gov.cn/" class="gx-link" target="_blank">沪ICP备13016609号-1</a></p>
        </div>
        <div class="col-md-3 big-size">
          <div class="row">
            <div class="col-sm-14">
              <p class="line-1 gray-8 text-right font-weight-bold">4008-212-999</p>
              <p class="line-2 gray-8 text-right">工作日 {{serverTime}}</p>
              <p class="line-3 gray-8 text-right">仅限上海地区</p>
            </div>
            <div class="col-sm-3"><img src="../img/common/wechat-new.png" width="86px" alt=""></div>
          </div>
        </div>

        <!--移动端显示-->
        <div class="col-12 small-size">
          <div class="row">
            <div class="col-9">
              <p class="line-1 font-weight-bold">4008-212-999</p>
              <p class="line-2">©上海嘉定及时雨小额贷款股份有限公司</p>
              <p class="line-3"><a href="https://beian.miit.gov.cn/" class="gx-link" target="_blank">沪ICP备13016609号-1</a></p>
            </div>
            <div class="col-3"><img src="../img/common/wechat-new.png" width="116px" alt=""></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  var phoneScale = parseInt(window.screen.width) / 750;
  document.write('<meta name="viewport" content="width=750, minimum-scale = ' + phoneScale + ', maximum-scale = ' + phoneScale + '">');
  export default {
    name: "Footer",
    data(){
          let serverTime = '09:00-21:00';
          let now = new Date(), thatTime = new Date('2020/01/24 00:00:00');
          if(now >= thatTime){
              serverTime = '9:00-11:30,13:00-17:30'
          }
        return {
            serverTime:serverTime
        }
    }
  }
</script>

<style scoped lang="less">

  //台式电脑、笔记本
  @media screen and (min-width: 769px) {
    .big-size{
      display: block;
    }
    .small-size{
      display: none;
    }
    .line-1{
      font-size:25px;
    }
    .line-2,.line-3{
      font-size:14px;
    }
  }

  //手机
  @media screen and (max-width: 768px) {
    .big-size{
      display: none;
    }
    .small-size{
      display: block;
    }
    .container{
      max-width:85%;
    }
    .line-1,.line-2,.line-3{
      text-align: left;
      font-size:30px;
    }
    .line-1{
      color:#AEAFB1;
    }
    .line-2,.line-3{
      color:#797E87;
      font-size:20px;
    }
  }

  #Footer{
    color:#fff;
    min-height:159px;
    background:#35383D;
    padding:31px 0 42px;

    .gray-8{
      color:#888;
    }
    .font-15{
      font-size:15px;
    }

    .list-link{
      overflow:hidden;
      li{
        float:left;
        padding:0 19px;
        a{
          color:#fff;
        }
      }
    }

    .line-1,.line-2,.line-3{
      margin:0;
    }

  }

  .gx-link {
    color: #888;
  }
  .gx-link:hover {
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue